<template>
  <div class="container about">
    <h1>公司簡介</h1>
    <div class="about_ch">
      <div class="about_top">
        <h2>時代至上的串聯 專業｜創意｜實力</h2>
        <h4>Taiwan's leading professional exhibition company</h4>
        <p>上聯國際展覽有限公司成立於1994年，至今已策劃超過1500場展覽，年逾50場展覽的經驗，為台灣展覽規模首屈一指的專業策展公司。主要服務項目為承辦國內外各類型展覽，及展覽徵展業務、議題創意、媒體公關、展覽顧問、整合行銷規劃、國際策展交流等。專業、創意、實力：堅持以「專業」展覽的Know-How、國際接軌的「創意」思維，及展覽執行的「實力」，貼近參展企業、民眾及消費通路的多元服務需求，為客戶提供全方位的展覽解決方案。</p>
        <h2>永續管理 不斷精進</h2>
        <p>上聯擁有健全的組織：台北總公司、高雄分公司、大陸分公司員工共120餘人。設有業務部、企劃部、公關部、管理部、票務行銷部、媒體採購部、整合開發部等相關部門，透過建立橫向溝通機制，及擁有獨立作業能力，充份發揮組織整體的運作效能，為客戶提供全套展覽解決方案，我們的團隊由一群熱情且富有創造力的專業人士組成，專注於細節，注重創新和時尚設計，且在展覽和會議領域擁有廣泛的經驗和深厚的專業知識，並通過專業的項目管理和現場營運來確保活動的順利進行。</p>
      </div>
      <div class="index_intro_target">
        <div class="target_item" v-for="item in introIcons" :key="item.title">
          <div><img :src="item.iconUrl"></div>
          <div>
            <h3 v-html="item.title"></h3>
            <p style="font-weight: bold;color:#00a0e9;" v-html="item.content"></p>
            <p class="sub_content" v-html="item.sub_content"></p>
          </div>
        </div>
      </div>
      <div class="about_sm" v-for="item in about_ch_list" :key="item.title">
        <h3 v-html="item.title"></h3>
        <p v-html="item.content"></p>
      </div>
      <div class="about_sm">
        <h3>承辦展覽業別：</h3>
        <ul>
          <li v-for="content in li_list_ch" :key="content"><i class="fa fa-circle"></i> {{content}}</li>
        </ul>
      </div>
    </div>

    <hr>

    <div class="about_en" style="margin-bottom: 30px;">
      <div class="about_top">
        <h2>TOP LINK</h2>
        <h4>Taiwan's leading professional exhibition company</h4>
        <p>Top Link have established and managed over 600 exhibitions since 1994 and held over 50 exhibitions per year, Top Link International Exhibition Group is Taiwan's leading professional exhibition company, and focuses on the organization of large-scale trade and consumer exhibitions, having a broad perspective and a commitment to in-depth levels of industry promotion.</p>
        <p>Professionalism, creativity and power are the key management philosophy of Top Link International. With these three key philosophy, Top Link International organizes world-class events and cultivate professional talent, giving limitless possibilities to the power and reach of exhibitions in people's lives.</p>
        <p>The business scope of Top Link International Group includes exhibition organization, PR relationship management, exhibition consultant, and dealers of world famous brands.</p>
        <p>Local and overseas exhibitions plan: Exhibition Planning, Exhibition Recruitment, Marketing, Media Promotion, Agenda operation, Exhibition Management, Ticketing Management, Creative Ideas, Public Relations Operations.</p>
      </div>
      <div class="about_sm" v-for="item in about_en_list" :key="item.title">
        <h3 v-html="item.title"></h3>
        <p v-html="item.content"></p>
      </div>
      <div class="about_sm">
        <h3>Industry of Exhibitions:</h3>
        <ul>
          <li v-for="content in li_list_en" :key="content"><i class="fa fa-circle"></i> {{content}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  props: {},
  metaInfo: {
      title: '公司簡介 │ TopLink 上聯國際展覽有限公司', // set a title
      meta: [{                 // set meta
        name: 'description',
        keywords: '上聯,展覽,公司簡介,公司介紹,活動',
        content: '上聯國際展覽公司成立於1994年，經營超過600場展覽的專業服務，年逾50 場展覽的經驗，百名員工專業服務，台灣展覽規模首屈一指的專業展覽公司。主要服務項目為承辦國內外各類型展覽，及展覽徵展業務、議題創意、媒體公關、展覽顧問、整合行銷規劃、國際策展交流等。專業、創意、實力：堅持以「專業」展覽的Know-How、國際接軌的「創意」思維，及展覽執行的「實力」，貼近參展企業、民眾及消費通路的多元服務需求。'
      }]
    },
  data () {
    return {
      introIcons: [
        {title: '關於我們', iconUrl: require('../../assets/index_intro/index_intro_sm02.jpg'), content: '精緻生活的產業 人文品味的內涵 優質專業的服務', sub_content: '<p>上聯國際展覽成立於1994年，以提供美好生活品味的展覽而努力。29年來，在全國各展覽中心，規劃出婚紗廣場、婦幼百貨、設計空間、自然造景、品牌名店、精緻餐飲以及藝文環境，讓消費者以感受生命中各種產業之美。</p><p>以『行銷』視角精準鎖定市場、『創意』打造各類產業展覽、『專業』展現業界品牌價值，上聯為各產業創造無限商機。</p>'},
        {title: '合作夥伴', iconUrl: require('../../assets/index_intro/index_intro_sm05.jpg'), content: '多元通路連結 與各公、協會及政府單位合作', sub_content: '合作夥伴：TCDA台灣咖啡發展協會、TICA 與貓共舞俱樂部、中華民國茶商業同業公會全國聯合會、中華民國資訊軟體協會、中華民國電器商業同業公會全國聯合會、中華民國對外貿易發展協會、中華會展經貿促進協會、台北市汽車代理商業同業公會、台北市旅行商業同業公會、台北市電器商業同業公會會、台灣區家具工業同業公會、台灣區教育用品工業同業公會、台灣陶瓷工業同業公會、台灣綠建材產業發展協會、社團法人台灣永續綠營建聯盟、社團法人台灣連鎖加盟促進協會、高雄市旅行商業同業公會、臺灣農業生技學會、聯合報系經濟日報…等單位'},
        {title: '展覽類型', iconUrl: require('../../assets/index_intro/index_intro_sm01.jpg'), content: '深耕產業展覽 行銷各大品牌', sub_content: '<p>上聯國際展覽公司，每年在台灣北中南各地有超過60檔展覽，打造出豐富多元的產業鏈，服務台灣上千家在地產業，每年吸引近千萬人次觀展。</p><p>上聯實績：全台最大室內年貨展-台北世貿大展暨禮品贈品展、上半年度全台最大旅展-台北國際觀光博覽會、亞洲首選-台灣唯一國際級-台北國際嬰兒與孕媽咪用品展、全台最大夏季室內運動展-運動用品暨戶外休閒展、開學最大台北3C展-台北3C電腦電器空調影音展、年度最具規模佛事盛會-台北國際佛事用品暨雕刻藝品展、全國最大蔬食饗宴-台北國際素食養生健康展…等</p>'},
        {title: '策展團隊', iconUrl: require('../../assets/index_intro/index_intro_sm04.jpg'), content: '全方位行銷策展團隊', sub_content: '深入了解客戶產業、熟知相關領域知識-業務部<br>源源不絕的創意且完整掌握行銷策略-企劃部<br>針對目標族群偏好，包裝出吸引消費者的形象-設計部<br>透過異業合作、各網路/實體平台創造宣傳最大效益-策略聯盟部<br>製造話題，透過媒體露出打造品牌形象-媒體採購部<br>熟稔數位趨勢、工具應用及網路整合服務-數位整合部'},
        {title: '願景', iconUrl: require('../../assets/index_intro/index_intro_sm03.jpg'), content: '開創行業新格局<br>促進台灣產業經濟發展', sub_content: '透過各界合作將展覽品牌化，活絡並為各產業打造標竿，藉此擴大產值、帶動社會經濟，追求各行業的永續發展。'}
      ],
      about_ch_list: [
        {title: '國內、國外展覽籌辦：', content: '展覽計劃、展覽徵展、展覽行銷、媒體宣傳、議題操作、展場管理、票務管理、展覽活動議題創意、公關媒體操作等展覽籌辦業務。'},
        {title: '公關行銷操作：', content: '行銷個案處理、議題式操作、公關行銷、策略制定、執行管理、品牌形象籌多元公關服務。'},
        {title: '展覽、會議顧問：', content: '展覽評估、展覽規劃、活動動線規劃、媒體公關操作、票務諮詢服務等全面性服務。'},
        {title: '整合行銷策略：', content: '事件行銷、公共關係、會議展覽、展場設計、通路行銷、社區行銷、企業行銷、廣告行銷。'},
        {title: '國際策展交流：', content: '跨文化/產業平台國際展覽交流活動、研討會/論壇、專業人士交流、城市交流晚宴、大型晚會等。'}
      ],
      about_en_list: [
        {title: 'PR Marketing Operations:', content: 'Marketing Case, Issue-based operations, Public Relations Marketing, Strategy Development, Executive Management, Brand Awareness Services.'},
        {title: 'Exhibitions, Conference Consultants:', content: 'Exhibition Evaluation, Planning, Ticketing Advisory Services and other services.'},
        {title: 'Integrated Marketing Strategy:', content: 'Event Marketing, Public Relations, Conventions, Exhibition Design, Marketing Channel, Community Marketing, Corporate Marketing, Advertising.'},
        {title: 'International Curatorial Exchanges:', content: 'International exhibitions of cross-cultural/industrial platforms, Seminars / Forums, Exchange of Professionals, etc.'}
      ],
      li_list_ch: ['電腦', '食品', '婚宴', '資訊軟體', '建材', '數位影音', '百貨家俱', '休閒觀光', '汽機車零配件', '資訊家電', '書商雜誌社', '珠寶', '渡假飯店', '汽車', '連鎖加盟', '旅行社'],
      li_list_en: ['Computer', 'Food', 'Wedding', 'Biotechnology-Beauty', 'Information software', 'Building Materials', 'Digital video', 'Department store', 'Leisure Sightseeing', 'Auto- Materials', 'Information appliances', 'Booksellers Magazine', 'Jewelry', 'Resort Hotel', 'Automobile', 'Franchise', 'Travel-agency']
    }
  }
}
</script>

<style lang="sass">
$p_color: #3c3c3c
$sm_title: #4e9d28

$pc-992-media: '992px'
$pad-768-media: '768px'
$mobile-576-media: '576px'

@mixin pc-width() 
  @media (max-width: $pc-992-media)
    @content

@mixin pad-width() 
  @media (max-width: $pad-768-media)
    @content

@mixin mobile-width() 
  @media (max-width: $mobile-576-media)
    @content

.about
  margin-top: 100px
  @include pad-width 
    margin-top: 20px
  h1 
    font-size: 45px
    font-weight: 400
    @include pad-width 
      font-size: 35px
  .about_ch
    .about_top 
      h2 
        font-size: 37px
        @include pad-width 
          font-size: 23px
      h4 
        font-size: 21px
        color: $p_color
        @include pad-width 
          font-size: 17px
      p 
        color: $p_color
        font-size: 17px
        letter-spacing: 1px
        line-height: 1.6
        font-weight: 500
        text-align: justify
        @include pad-width 
          font-size: 15px
    .about_sm
      h3 
        color: $sm_title
        font-size: 29px
        @include pad-width 
          font-size: 21px
      p 
        color: $p_color
        font-size: 17px
        letter-spacing: 1px
        line-height: 1.6
        font-weight: 500
        text-align: justify
        @include pad-width 
          font-size: 15px
      ul 
        display: flex
        flex-flow: row wrap
        list-style-type: none
        margin: 0
        padding: 0
        li 
          width: 25%
          padding: 10px
          color: $p_color
          font-size: 17px
          @include pad-width 
            width: 50%
            font-size: 15px
  .about_en
    .about_top 
      h2 
        font-size: 37px
        @include pad-width 
          font-size: 23px
      h4 
        font-size: 21px
        color: $p_color
        @include pad-width 
          font-size: 17px
      p 
        color: $p_color
        font-size: 17px
        line-height: 1.6
        font-weight: 500
        word-wrap: break-word
        @include pad-width 
          font-size: 15px
    .about_sm
      h3 
        color: $sm_title
        font-size: 29px
        @include pad-width 
          font-size: 21px
      p 
        color: $p_color
        font-size: 17px
        line-height: 1.6
        font-weight: 500
        word-wrap: break-word
        @include pad-width 
          font-size: 15px
      ul 
        display: flex
        flex-flow: row wrap
        list-style-type: none
        margin: 0
        padding: 0
        li 
          width: 25%
          padding: 10px
          color: $p_color
          font-size: 17px
          @include pad-width 
            width: 50%
            font-size: 15px

.index_intro_target
  display: flex
  justify-content: space-around
  align-items: flex-start
  flex-flow: row wrap
  margin-top: 30px
  .target_item
    width: 33.33333334%
    margin-top: 20px
    div:nth-child(1)
      height: 113px
      display: flex
      align-items: center
      justify-content: center
    div:nth-child(2)
      padding: 0 20px
    &:last-child 
      div:nth-child(2)
        border-right: none
  img 
    display: block
  h3 
    text-align: center
    color: #00a0e9
  p 
    text-align: center
    font-size: 14px
    color: grey
  .sub_content
    // text-align: left
    p
      // text-align: left
  @include pc-width
    .target_item
      width: 50%
  @include mobile-width
    .target_item
      width: 100%

hr 
  padding: 5px 0
  background-color: #e7e7e7
  border: none
  margin-bottom: 20px
  margin-top: 30px
  @include pad-width 
    padding: 2px 0
    margin-bottom: 10px
    margin-top: 15px
</style>
